export default __webpack_public_path__ + "55121667974e6dad4a50efbc9013a743.png";